import Vue from "vue";

export default function redirectToPasswordReset()
{
    
    if (Vue.prototype.$cache.get('redirect-to-password-reset'))
    {
        return 'create-account-just-by-setting-password';
    }

    return false;
}
